module.exports = __webpack_public_path__ + "img/doctor.254680cb.png";